"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionalBorrowerCreditSchema = void 0;
var transactional_borrower_credit_address_schema_1 = require("./transactional-borrower-credit-address-schema");
var transactional_credit_check_schema_1 = require("./transactional-credit-check-schema");
var transactional_credit_report_schema_1 = require("./transactional-credit-report-schema");
exports.transactionalBorrowerCreditSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'transactionalBorrowerCreditID',
        'cmhcAccountNumber',
        'applicationIDTimestamp',
        'typeID',
        'address',
        'telephoneLocalNumberAreaCode',
        'telephoneLocalNumber',
        'localTelephoneExtensionNumber',
        'canadianIncomePredictorScoreRequestIndicator',
        'creditCardID',
        'creditCardName',
        'nonPermanentResidentIndicator',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
    ],
    properties: {
        transactionalBorrowerCreditID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        cmhcAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        applicationIDTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        typeID: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        address: transactional_borrower_credit_address_schema_1.transactionalBorrowerCreditAddressSchema,
        birthDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        telephoneLocalNumberAreaCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        telephoneLocalNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        localTelephoneExtensionNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        canadianIncomePredictorScoreRequestIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        creditCardID: {
            type: 'string',
            minLength: 0,
            maxLength: 25,
            errorMessage: 'should have variable length up to 25 characters',
        },
        creditCardName: {
            type: 'string',
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
        },
        nonPermanentResidentIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        transactionalCreditReport: {
            type: ['array', 'null'],
            items: transactional_credit_report_schema_1.transactionalCreditReportSchema,
        },
        transactionalCreditCheck: {
            type: ['array', 'null'],
            items: transactional_credit_check_schema_1.transactionalCreditCheckSchema,
        },
    },
};
